import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { UpdateAvailabilityInputType } from "operations/schema/schema";
import { AppAsyncThunkConfig } from "store";
import { State } from "./calendar.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncMutations = {
  updateAvailability: createAppAsyncThunk(
    "calendar/updateAvailability",
    async (
      props: { availability: UpdateAvailabilityInputType },
      { rejectWithValue, extra: { sdk } }
    ) => {
      const { ...variables } = props;
      const { data, errors } = await graphqlRequest(sdk.updateAvailability, {
        thunkName: "calendar/updateAvailability",
        thunkProps: props,
        variables,
      });
      if (errors) return rejectWithValue(errors);
      if (!data?.updateAvailability) return rejectWithValue("something went wrong");
      return data;
    }
  ),
};

export const mutationBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncMutations.updateAvailability.pending, (state) => {
    state.mobileCalendar.loading = true;
    return state;
  });
  builder.addCase(asyncMutations.updateAvailability.rejected, (state) => {
    state.mobileCalendar.loading = false;
    return state;
  });
  builder.addCase(asyncMutations.updateAvailability.fulfilled, (state) => {
    state.mobileCalendar.loading = false;
    return state;
  });
};
